






import {Component, Vue, Prop} from 'vue-property-decorator'

@Component({})
export default class Overlay extends Vue {}
